import { render, staticRenderFns } from "./EditResourceAuditFlow.vue?vue&type=template&id=2ed5b983"
import script from "./EditResourceAuditFlow.vue?vue&type=script&lang=js"
export * from "./EditResourceAuditFlow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports